import React from 'react'
import { Helmet } from 'react-helmet'
import Breadcrumb from '../components/Breadcrumb'
import AbtAbout from '../components/AbtAbout'
import AbtWhyUs from '../components/AbtWhyUs'
import AbtBrand from '../components/AbtBrand'
const About = () => {
  
  return (
    <>
    <Helmet>
      <title>About Us - Om Softwares | Digital Marketing & Web Development Agency</title>
      <meta name="description" content="Learn about Om Softwares, a leading digital marketing and web development agency based in Nangal, Punjab. We deliver creative branding, SEO, social media marketing, and custom web solutions." />
      <meta property="og:title" content="About Us - Om Softwares" />
      <meta property="og:description" content="Learn about Om Softwares — creative branding, SEO, social media marketing, and custom web solutions." />
      <meta property="og:image" content="https://omsoftwares.in/assets/img/seo/ogImage.png" />
      <meta property="og:url" content="https://omsoftwares.in/about" />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="About Us - Om Softwares" />
      <meta name="twitter:description" content="Learn about Om Softwares — creative branding, SEO, social media marketing, and custom web solutions." />
      <meta name="twitter:image" content="https://omsoftwares.in/assets/img/seo/ogImage.png" />
    </Helmet>
    <main>
      <Breadcrumb name="About Us"/>
      <AbtAbout/>
      <AbtWhyUs/>
      <AbtBrand/>
    </main>
    </>
  )
}

export default About
